<template>
    <v-container class="fill-screen d-flex justify-center align-center">
        <v-row class="justify-center align-center ">
            <v-col cols="auto">
                <PasswordChangeCard
                    :passwordCardUser="passwordUserFullName"
                />
            </v-col>
        </v-row>
    </v-container>
</template>
  
<script>
  
import PasswordChangeCard from '../components/PasswordChangeCard.vue';
  
export default {
    components: {
        PasswordChangeCard
    },

    data(){
        return{
            passwordUserFullName: 'Kein Benutzer angemeldet'
        }
    },
    mounted(){
        this.getUser();
    },
    methods: {
        async getUser(){
            const response = await this.$axios.get('/api/users/') 
            this.passwordUserFullName = response.data.current_user_firstname + " " + response.data.current_user_lastname
        }
    }
}
</script>

<style scoped>

.fill-screen {
  height: 100vh;        /* Voller Bildschirm */
  padding: 0;           /* Entfernt Standard-Abstände */
}
</style>